<template>
  <div class="registerbox">
    <v-time-down-panel :time="10" text="密码重置成功" btnText="返回登录" @end="onClick" @click="onClick"
      :show.sync="panelShow" />
  </div>
</template>

<script>
import httpClient from '@/api/base'

export default {
  name: "ResetPasswordSuccess",
  data() {
    return {
      loading: false,
      panelShow: true,
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    onClick() {
      // const redirect_uri = this.$route.query.redirect_uri
      // if (redirect_uri && redirect_uri.startsWith("http")) {
      //   window.location.href = redirect_uri
      // } else if (redirect_uri) {
      //   this.$router.push({
      //     path: redirect_uri
      //   })
      // } else {
      //   this.$router.push({
      //     name: "Home"
      //   })
      // }
      this.$router.push({
        name: "Home"
      })

    },
    fetchData() {
    }
  }
};
</script>
